/** Initialise every actual contact form, including forms mounted after navigation. */
const loads = new WeakMap<HTMLFormElement, Promise<string>>()
const loadedAt = new WeakMap<HTMLFormElement, number>()
export function leadFormElapsed(form: HTMLFormElement): number {
  const start = loadedAt.get(form);
  return start === undefined ? 0 : Math.round(performance.now() - start);
}
export async function requestFormToken(): Promise<string> {
  const base = import.meta.env.VITE_SUPABASE_URL;
  if (!base) throw new Error('Form unavailable');
  const response = await fetch(`${base}/functions/v1/form-load`, {
    method: 'POST', headers: { apikey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY },
  });
  if (!response.ok) throw new Error('Form unavailable');
  const data = await response.json();
  return typeof data.token === 'string' ? data.token : '';
}
export function initialiseLeadForms(): () => void {
  const scan = () => {
    document.querySelectorAll<HTMLFormElement>('form[action*="/lead-intake"]').forEach(form => {
      if (loads.has(form)) return;
      loadedAt.set(form, performance.now());
      const load = requestFormToken().then(token => {
        let input = form.querySelector<HTMLInputElement>('input[name="form_token"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden'; input.name = 'form_token'; form.appendChild(input);
        }
        input.value = token;
        return token;
      }).catch(() => { loads.delete(form); return ''; });
      loads.set(form, load);
    });
  };
  scan();
  const observer = new MutationObserver(scan);
  observer.observe(document.body, { childList: true, subtree: true });
  return () => observer.disconnect();
}